module.exports = __webpack_public_path__ + "img/mission_pic.f1db7784.jpg";